import React from 'react';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import { images } from '../../constants'
import './About.scss'

const abouts = [
  { title: "Software Engineer", description: "I solve problems. I build things. I like numbers. I embrace data.", imgUrl: images.about01 },
  { title: "Full Stack Developer", description: "I do both Front-end and Back-end.", imgUrl: images.about02 },
  { title: "Fashion Enthusiast", description: "I have a keen eye for aesthetics and I am not afraid to think out of the box.", imgUrl: images.about03 },
  { title: "Watch Nerd", description: "I can talk about watches all day.", imgUrl: images.about04 },
];

const About = () => {
  return (
    <>
      <h2 className="q-text">The ideal engineer is a composite … He is not a scientist, he is not a mathematician, he is not a sociologist or a writer; but he may use the knowledge and techniques of any or all of these disciplines in solving engineering problems.”
 — Nathan W. Dougherty</h2>

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={about.imgUrl} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>{about.title}</h2>
            <p className="p-text" style={{ marginTop: 10 }}>{about.description}</p>
          </motion.div>
        ))}
      </div>
    </>
  )
}

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg',
);